import { memo } from 'react';
import { useTheme } from '@mui/material/styles';

import { formatToAmount, convertPxToNumber } from '../../../../../../constants/helpers/utils';

interface Props {
  cx: number;
  cy: number;
  amount: number;
}

const ChartAmountInfo = ({ cx, cy, amount }: Props) => {
  const theme = useTheme();

  return (
    <text
      fill={theme.typography.h3.color}
      fontSize={theme.typography.h3.fontSize}
      fontWeight={theme.typography.h3.fontWeight}
      x={cx}
      y={cy - 10}
      dy={convertPxToNumber(theme.typography.h3.fontSize) / 2}
      textAnchor="middle"
    >
      {formatToAmount(amount)}
    </text>
  );
};

export default memo(ChartAmountInfo);
